import { render, staticRenderFns } from "./ProHighlights2.vue?vue&type=template&id=37c67a2a&scoped=true&"
import script from "./ProHighlights2.vue?vue&type=script&lang=js&"
export * from "./ProHighlights2.vue?vue&type=script&lang=js&"
import style0 from "./ProHighlights2.vue?vue&type=style&index=0&id=37c67a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c67a2a",
  null
  
)

export default component.exports